var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGuterSchutz = function SvgGuterSchutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.127,
    height: 88.51
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-schutz_svg__a",
    x1: -2.164,
    x2: 9.306,
    y1: 31.863,
    y2: 33.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-schutz_svg__a",
    id: "guter-schutz_svg__c",
    x1: 60.837,
    x2: 67.853,
    y1: 42.814,
    y2: 43.841
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-schutz_svg__b",
    x1: 29.442,
    x2: 41.801,
    y1: 35.621,
    y2: 25.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0b2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-schutz_svg__a",
    id: "guter-schutz_svg__d",
    x1: 40.324,
    x2: 27.674,
    y1: 31.277,
    y2: 26.767
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-schutz_svg__b",
    id: "guter-schutz_svg__e",
    x1: 29.442,
    x2: 41.801,
    y1: 56.929,
    y2: 46.397
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-schutz_svg__a",
    id: "guter-schutz_svg__f",
    x1: 40.324,
    x2: 27.674,
    y1: 52.585,
    y2: 48.075
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-schutz_svg__a",
    id: "guter-schutz_svg__g",
    x1: 4.008,
    x2: 56.274,
    y1: 32.546,
    y2: 40.203
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__a)",
    d: "M6.04 20.696a561 561 0 0 1-6.038-1.502 123.2 123.2 0 0 0 3.162 26.437q3.008-.875 5.873-1.501a120 120 0 0 1-2.996-23.434",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__c)",
    d: "M64.416 30.404a108.8 108.8 0 0 1-4.908 22.776 56 56 0 0 1 4.936 4.035c2.997-7.566 5.084-17.54 6.057-26.859a77 77 0 0 1-6.085.048",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M35.563 88.51S53.2 73.588 59.513 66.118c9.008-10.651 13.495-42.895 10.87-56.575L35.563 0 .744 9.554c-2.625 13.67 1.861 45.913 10.87 56.564 6.313 7.47 23.95 22.392 23.95 22.392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M34.963 80.023c-5.313-4.655-14.81-13.155-18.74-17.79C9.728 54.55 5.183 29.403 6.156 14.968l.044-.646 29.364-8.062 29.365 8.051.044.646c.973 14.433-3.572 39.58-10.068 47.263C50.71 67.18 40.4 76.324 36.162 80.024l-.6.524Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M35.563 79.338c-6.058-5.308-14.9-13.277-18.644-17.693-6.37-7.534-10.8-32.6-9.855-46.617l28.5-7.824 28.499 7.814c.945 14.016-3.49 39.083-9.855 46.613-3.747 4.434-12.587 12.417-18.645 17.707"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m17.105 63.235-.15-.168c-.26-.288-.507-.57-.731-.833C9.727 54.55 5.182 29.402 6.155 14.967l.044-.646L34.286 6.61 6.018 13.662l-.468.128-.033.485-.043.646C4.492 29.477 9.11 54.88 15.702 62.675a68 68 0 0 0 6.065 5.32c-1.786-1.729-3.402-3.367-4.662-4.76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__b)",
    d: "m36.037 20.836 2.293 4.646a.44.44 0 0 0 .33.24l5.128.746a.44.44 0 0 1 .244.75l-3.71 3.616a.44.44 0 0 0-.127.39l.876 5.106a.44.44 0 0 1-.638.464l-4.586-2.411a.44.44 0 0 0-.41 0l-4.585 2.41a.44.44 0 0 1-.638-.463l.875-5.106a.44.44 0 0 0-.126-.39l-3.71-3.616a.44.44 0 0 1 .244-.75l5.127-.745a.44.44 0 0 0 .331-.24l2.293-4.647a.44.44 0 0 1 .789 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__d)",
    d: "M35.642 20.591a.44.44 0 0 1 .395.245l2.293 4.646a.44.44 0 0 0 .33.24l5.128.746a.44.44 0 0 1 .244.75l-3.71 3.616a.44.44 0 0 0-.127.39l.876 5.106a.439.439 0 0 1-.638.464l-4.586-2.411a.44.44 0 0 0-.41 0l-4.585 2.41a.439.439 0 0 1-.638-.463l.876-5.106a.44.44 0 0 0-.127-.39l-3.71-3.616a.44.44 0 0 1 .244-.75l5.127-.745a.44.44 0 0 0 .331-.24l2.293-4.647a.44.44 0 0 1 .394-.245m0-.455a.89.89 0 0 0-.802.499l-2.293 4.646-5.116.736a.895.895 0 0 0-.496 1.527l3.71 3.616-.88 5.093a.894.894 0 0 0 1.299.944l4.586-2.411 4.57 2.41a.895.895 0 0 0 1.3-.943l-.876-5.106 3.705-3.603a.895.895 0 0 0-.496-1.527l-5.127-.745-2.28-4.637a.89.89 0 0 0-.804-.5",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m30.542 36.772.876-5.106a.44.44 0 0 0-.127-.39l-.213-.207a.4.4 0 0 1 .011.154l-.875 5.107a.43.43 0 0 0 .333.49c.001-.017-.008-.03-.005-.048M38.658 25.925a.44.44 0 0 0 .33.24l5.128.745c.014.002.021.013.035.016a.43.43 0 0 0-.363-.458l-5.127-.745a.4.4 0 0 1-.129-.052ZM27.825 26.91l5.127-.745a.44.44 0 0 0 .331-.24l2.293-4.646a.434.434 0 0 1 .583-.194l-.122-.249a.44.44 0 0 0-.79 0l-2.292 4.646a.44.44 0 0 1-.331.24l-5.127.746a.44.44 0 0 0-.244.75l.207.201a.436.436 0 0 1 .365-.509"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__e)",
    d: "m36.037 42.144 2.293 4.646a.44.44 0 0 0 .33.24l5.128.745a.44.44 0 0 1 .244.75l-3.71 3.617a.44.44 0 0 0-.127.39l.876 5.106a.44.44 0 0 1-.638.463l-4.586-2.41a.44.44 0 0 0-.41 0l-4.585 2.41a.44.44 0 0 1-.638-.463l.875-5.107a.44.44 0 0 0-.126-.389l-3.71-3.616a.44.44 0 0 1 .244-.75l5.127-.745a.44.44 0 0 0 .331-.241l2.293-4.646a.44.44 0 0 1 .789 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__f)",
    d: "M35.642 41.899a.44.44 0 0 1 .395.245l2.293 4.646a.44.44 0 0 0 .33.24l5.128.745a.44.44 0 0 1 .244.75l-3.71 3.617a.44.44 0 0 0-.127.39l.876 5.106a.439.439 0 0 1-.638.463l-4.586-2.41a.44.44 0 0 0-.41 0l-4.585 2.41a.439.439 0 0 1-.638-.463l.876-5.107a.44.44 0 0 0-.127-.389l-3.71-3.616a.44.44 0 0 1 .244-.75l5.127-.745a.44.44 0 0 0 .331-.241l2.293-4.646a.44.44 0 0 1 .394-.245m0-.456a.89.89 0 0 0-.802.5l-2.293 4.645-5.116.737a.895.895 0 0 0-.496 1.527l3.71 3.616-.88 5.093a.894.894 0 0 0 1.299.943l4.586-2.41 4.57 2.41a.895.895 0 0 0 1.3-.943l-.876-5.107 3.706-3.602a.895.895 0 0 0-.497-1.527l-5.127-.745-2.28-4.638a.89.89 0 0 0-.804-.499",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m30.542 58.08.876-5.106a.44.44 0 0 0-.127-.39l-.213-.207a.4.4 0 0 1 .011.154l-.875 5.107a.43.43 0 0 0 .333.49c.001-.017-.008-.03-.005-.048M38.658 47.232a.44.44 0 0 0 .33.24l5.128.746c.014.002.021.013.035.016a.43.43 0 0 0-.363-.458l-5.127-.746a.4.4 0 0 1-.129-.052ZM27.825 48.218l5.127-.745a.44.44 0 0 0 .331-.24l2.293-4.647a.434.434 0 0 1 .583-.193l-.122-.25a.44.44 0 0 0-.79 0l-2.292 4.647a.44.44 0 0 1-.331.24l-5.127.746a.44.44 0 0 0-.244.75l.207.201a.436.436 0 0 1 .365-.509"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-schutz_svg__g)",
    d: "M9.732 43.057a75.8 75.8 0 0 1 15.427-1.666A58.2 58.2 0 0 1 59.051 51.73a110.3 110.3 0 0 0 4.335-20.452c-17.472-.668-41.674-5.874-56.397-9.416a122 122 0 0 0 2.743 21.195",
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  })));
};
export default SvgGuterSchutz;